import 'fetch-polyfill';
import { createApp } from 'vue';
import App from './App.vue';
import router from '@/router';
import store from '@/store';

import vuetify from '@/plugins/vuetify';
import i18n from '@/plugins/i18n';
import { CognitoPlugin } from '@/plugins/cognito';

const app = createApp(App);
app.use(router).use(store).use(vuetify).use(i18n).use(CognitoPlugin).mount('#app');
